import { createContext, useContext } from 'react';
import { Patient } from 'api/account/patients.type';
import { FCWithChildren } from 'helpers/types/FCWithChildren';

import { useCurrentUser } from './CurrentUserContext';

export interface AccountPatientsContext {
  patients: Patient[];
  isLoaded: boolean;
}

const AccountPatientsContext = createContext<AccountPatientsContext>({
  patients: [] as Patient[],
  isLoaded: false,
});

export const AccountPatientsProvider: FCWithChildren<{}> = ({ children }) => {
  const {
    state: { isInitialized, isLoading, members, account },
  } = useCurrentUser();

  const isLoaded = isInitialized && !isLoading;

  const context: AccountPatientsContext = {
    isLoaded,
    patients: members ?? [],
  };

  return (
    <AccountPatientsContext.Provider value={context}>
      {isLoaded || !account ? children : null}
    </AccountPatientsContext.Provider>
  );
};

export const useAccountPatients = () => {
  const context = useContext<AccountPatientsContext>(AccountPatientsContext);

  if (!context)
    throw new Error(
      '!--- useAccountPatients must be used inside a AccountPatientsProvider ---!',
    );

  return context;
};
